import script from "./HrTab.vue?vue&type=script&setup=true&lang=js"
export * from "./HrTab.vue?vue&type=script&setup=true&lang=js"

import "./HrTab.vue?vue&type=style&index=0&id=25013f50&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25013f50"]])

export default __exports__
import QTab from 'quasar/src/components/tabs/QTab.js';
import QRouteTab from 'quasar/src/components/tabs/QRouteTab.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QTab,QRouteTab,QIcon});
